"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatRecipe = void 0;
function concatRecipe(iterateAll) {
    return function (...iterables) {
        return iterateAll([this, ...iterables]);
    };
}
exports.concatRecipe = concatRecipe;
